import React from "react";
import PropTypes from "prop-types";
import "./CustomButton.scss";
import { ButtonSpinner } from "./ButtonSpinner";

const CustomButton = ({
  children,
  variant = "default",
  disabled = false,
  loading = false,
  onClick,
  type = "button",
  className = "",
  fullWidth = false,
  ...rest
}) => {
  const isDisabled = disabled || loading;

  const buttonClass = `custom-button custom-button--${variant} ${isDisabled ? "custom-button--disabled" : ""} ${
    loading ? "custom-button--loading" : ""
  } ${fullWidth ? "custom-button--full-width" : ""} ${className}`.trim();

  return (
    <button type={type} className={buttonClass} onClick={onClick} disabled={isDisabled} {...rest}>
      {children}
      {loading && (
        <span className="custom-button__loader">
          <ButtonSpinner />
        </span>
      )}
    </button>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "text", "disabled", "error"]),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default CustomButton;
